import React from 'react'
import { useQuery, useMutation } from 'react-query'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@material-ui/core'

import { HierarchyTree } from 'src/components/Tree'
import { Facility, Hierarchy, Place } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import { AxiosError } from 'axios'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import toast from 'react-hot-toast'

interface CreatePlace {
  parent?: string
  name: string
  facility: string
}

interface HierarchyEditProps {
  facility: Facility
  open: boolean
  handleClose: () => void
  onSave?: () => void
}

export const HierarchyEditDialog = (props: HierarchyEditProps) => {
  const { facility, open, handleClose, onSave } = props
  const { data: hierarchy, isLoading: hierarchyLoading } = useQuery(['facilitiy-hierarchy', facility.guid], () =>
    skuit.sc.facilities.hierarchy(facility.guid as string)
  )

  const { mutate: createPlaces, isLoading } = useMutation(skuit.sc.places.bulkCreatePlaces, {
    onSuccess: (newPlace: Place) => {
      if (onSave) {
        onSave()
      }

      toast.success(() => (
        <Notification message={'Successfully saved Hierarchy'} newObject={newPlace} />
      ))
      handleClose()
    },
    onError: (error: AxiosError) => {
      handleErrorMessage(error, 'sav', 'Hierarchy')
      setApiErrors(formData.setError, error)
    },
  })

  const { Form, data: formData } = useForm()

  const onSubmit = () => {
    const toCreate: CreatePlace[] = []
    const getNewPlaces = (hierarchy: Hierarchy[], facility: string, parent?: string) => {
      hierarchy.map((item) => {
        const place = {
          ident: item.guid,
          facility: facility,
          parent,
          name: item.label as string,
        }
        if (item.toCreate) {
          toCreate.push(place)
        }
        if (item.children?.length) {
          const currentFacility = item.guid?.startsWith('fa_') ? item.guid : facility
          const currentParent = item.guid?.startsWith('fa_') ? undefined : item.guid
          getNewPlaces(item.children, currentFacility, currentParent)
        }
        return null
      })
    }
    getNewPlaces(hierarchy, '')
    createPlaces(toCreate)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Edit {facility.name} Hierarchy</DialogTitle>
      <DialogContent>
        {hierarchyLoading ? (
          <LinearProgress />
        ) : (
          <HierarchyTree roots={hierarchy} edit />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Form onSubmit={onSubmit}>
          <Button type="submit" color="primary" autoFocus disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Form>
      </DialogActions>
    </Dialog>
  )
}
